var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCogMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M13.88 1.67l.419.084.083.027c.159.066.274.21.303.381l.008.087v2.08c.82.288 1.589.71 2.273 1.248l.287.237 1.795-1.041c.18-.103.4-.085.559.038l.064.06.258.29c.84.987 1.492 2.12 1.923 3.345l.123.37.018.085a.515.515 0 01-.103.379A8.08 8.08 0 0016 6.8c-1.513 0-2.93.415-4.141 1.138-2.167.073-3.901 1.862-3.901 4.058 0 .377.05.742.146 1.088a8.104 8.104 0 004.948 9.362c-.978.1-1.966.06-2.936-.116l-.415-.084-.083-.026a.508.508 0 01-.305-.382l-.007-.087v-2.083a7.94 7.94 0 01-2.273-1.249l-.288-.238-1.795 1.042a.504.504 0 01-.559-.038l-.064-.06-.258-.29a10.556 10.556 0 01-1.923-3.345l-.123-.37-.018-.086a.51.51 0 01.178-.456l.072-.05 1.794-1.042a8.238 8.238 0 01-.06-2.603l.06-.37-1.794-1.04a.509.509 0 01-.25-.507l.018-.086.122-.37a10.5 10.5 0 011.924-3.345l.258-.29.064-.06a.495.495 0 01.48-.075l.08.037 1.792 1.042a8.17 8.17 0 012.213-1.353l.347-.134V2.25a.51.51 0 01.313-.469l.083-.026.38-.078a10.561 10.561 0 013.802-.007zM16 8.4a6.501 6.501 0 010 13 6.501 6.501 0 010-13zm3.3 5.4h-6.6a.558.558 0 00-.55.563v1.125c0 .309.248.562.55.562h6.6c.302 0 .55-.253.55-.563v-1.124a.558.558 0 00-.55-.563z"
  }))));
}

export default SvgCogMinus;